import React, { useEffect, useRef } from "react";

import classes from "./ClickableCard.module.css";
import { gsap } from "gsap";
import { Draggable } from "gsap/all";

//Wrap components with this Card to make them scale down and up when you click on them
// it creates a cool clicking effect
const ClickableCard = React.forwardRef((props,card) => {
  const t1 = gsap.timeline();

  //Scale down The Card when u hover away or click down the mouse
  const scaledown = () => {
    gsap.timeline().to(card.current, {
      duration: 0.2,
      scale: 1,
    });
  };
  //Scale up The Card when u hover or mouse release
  const scaleup = () => {
    gsap.timeline().to(card.current, {
      duration: 0.2,
      scale: "+=" + 0.1,
    });
  };

  const onMouseOver = (event) => {
    scaleup();
    if (props.onMouseOver != undefined) {
      props.onMouseOver(event);
    }
  };
  const onMouseOut = (event) => {
    scaledown();
    if (props.onMouseOut != undefined) {
      props.onMouseOut(event);
    }
  };
  const onMouseDown = () => {
    scaledown();
    if (props.onMouseDown != undefined) {
      props.onMouseDown();
    }
  };
  const onMouseUp = () => {
    scaleup();
    if (props.onMouseUp != undefined) {
      props.onMouseUp();
    }
  };

  return (
    <div
      className={classes.container + " " + props.className}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      ref={card}
      onClick={props.onClick}

      style={{width: `${props.width}px`, height:`${props.height}px`,backgroundColor:`${props.backgroundColor}`}}
    >
      {props.children}
    </div>
  );
})
export default ClickableCard;
